import { STATUS_GROUPS } from '../../utils/statusConstants'

export const processVisits = (visits = [], statuses, settings, fancyProcessing = true) => {
  let inPatients = []

  for (let tmp of visits) {
    let statusGroup = statuses[tmp.status]?.group
    if (
      settings?.showSmartCensus &&
      tmp?.isSmartCensusVisit &&
      statusGroup === STATUS_GROUPS.available
    ) {
      statusGroup = statuses['Checked In']?.group
    }
    tmp = { ...tmp, statusGroup: statusGroup }

    if (
      tmp.diagnosis_code_primary &&
      Array.isArray(tmp.diagnosis_code_primary) &&
      tmp.diagnosis_code_primary.length > 0
    ) {
      if (tmp.diagnosis_code_primary && tmp.diagnosis_code_primary[0]) {
        tmp = {
          ...tmp,
          diagnosis_code_primary: {
            ...tmp.diagnosis_code_primary?.[0],
            description:
              tmp.diagnosis_code_primary && tmp.diagnosis_code_primary[0]
                ? tmp.diagnosis_code_primary?.[0].description
                : '',
            code: tmp.diagnosis_codes?.[0] || tmp.diagnosis_code_primary.code,
          },
        }
      }
    } else if (
      (!tmp.diagnosis_code_primary || tmp.diagnosis_code_primary.length === 0) &&
      tmp.diagnosis_codes &&
      tmp.diagnosis_codes.length > 0
    ) {
      tmp = {
        ...tmp,
        diagnosis_code_primary: {
          description: '',
          code: tmp.diagnosis_codes?.[0] || '',
        },
      }
    }

    if (fancyProcessing) {
      tmp.visitId = tmp._id
      let tmp_dx = []
      if (tmp.diagnosisCodeList && tmp.diagnosisCodeList.length > 0) {
        tmp_dx = tmp.diagnosisCodeList.filter((dx) => {
          return dx.code === tmp.diagnosis_codes[0]
        })
      }
      if (tmp_dx && tmp_dx[0]) {
        tmp.diagnosis_code_primary = tmp_dx[0]
      }

      if (tmp.service_lines && tmp.service_lines.length > 0) {
        tmp.service_lines = tmp.service_lines.filter((line) => line.procedure_code)
      }
    }

    inPatients.push(tmp)
  }
  return inPatients
}
